import React from "react";

import { Route, Routes, useLocation } from "react-router-dom";

import dynamicRoutes from "dynamicRoutes.js";

function Dashboard(props) {
  const routes = dynamicRoutes["public"];

  return (
    <div className="min-h-screen ">
      <Routes>
        {routes.map((prop, key) => {
          return (
            <Route path={prop.path} element={prop.component} key={key} exact />
          );
        })}
      </Routes>
    </div>
  );
}

export default Dashboard;
